import script from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=js"
export * from "./UnauthorizedView.vue?vue&type=script&setup=true&lang=js"

import "./UnauthorizedView.vue?vue&type=style&index=0&id=20837cfc&lang=css"

const __exports__ = script;

export default __exports__